/*
课程评论组件 会显示课程详情 包含当前课程的套餐课 专题课
courseInfo: 课程详情数据

*/

<template>
  <div class="comment"  v-loading="map.isComment">
    <div
      v-if="token && courseInfo.buyStatus"
      class="comment_add_box relative"
    >
      <div class="relative">
        <el-input
          v-model="map.commentText"
          type="textarea"
          :rows="2"
          maxlength="500"
          show-word-limit
          class="font14"
          placeholder="请输入..."
        />
        <span class="limit_count_box">{{ map.commentText.length }} / 500</span>
      </div>
      <div class="comment_add_btn">
        <emoji-box @select="handleSelectEmoji($event, map)" />
        <el-button
          type="primary"
          :disabled="map.commentText === 0"
          class="comment_btn"
          @click="handleSaveComment(map.commentText)"
        >
          评论
        </el-button>
      </div>
    </div>
    <div class="all_txt">
      全部评论&nbsp;{{ commentPage.totalCount }}
    </div>
    <div class="course_comment_list">
      <div
        v-for="(comment, x) in map.commentList"
        :key="x"
        class="course_comment_item"
      >
        <div class="course_comment_cover">
          <el-avatar
            :size="48"
            class="comment_cover_img"
            :src="comment.headPortrait"
          />
        </div>
        <div class="course_comment_content">
          <div class="course_comment_user">
            {{ comment.userName }}
          </div>
          <div
            class="course_comment_int"
            :class="{ 'tx-ov-2': !comment.showContent }"
          >
            {{ comment.commentContent }}
          </div>
          <el-button
            v-if="comment.commentContent.length > 137"
            type="text"
            @click="comment.showContent = !comment.showContent"
          >
            {{ comment.showContent ? "收起" : "展开" }}
          </el-button>
          <div
            class="course_comment_btn"
            :class="{ has: comment.replyList }"
          >
            <div class="course_comment_time">
              {{ comment.gmtCreate }}
            </div>
            <div class="comment_btn_list">
              <!--                    <div class="btn_icons" @mouseover="handleFocus(comment,'report')" @mouseleave="handleBlur(comment,'report')" :class="{hover:comment.report}">-->
              <!--                      <span class="iconfont icon-report"></span>-->
              <!--                      <span class="btn_text">举报</span>-->
              <!--                    </div>-->
              <div
                v-if="userInfo && userInfo.id !== comment.userId"
                class="btn_icons"
                :class="{ hover: comment.add }"
                @click="handleShowComment(comment)"
                @mouseover="handleFocus(comment, 'add')"
                @mouseleave="handleBlur(comment, 'add')"
              >
                <span class="iconfont icon-comment" />
                <span class="btn_text">回复</span>
              </div>
              <!--                    <div class="btn_icons" @mouseover="handleFocus(comment,'love')" @mouseleave="handleBlur(comment,'love')" :class="{hover:comment.love,active:comment.like}">-->
              <!--                      <span class="iconfont" :class="{'icon-like':(!comment.love&&!comment.like),'icon-like1':comment.love||comment.like}"></span>-->
              <!--                      <span class="btn_text">{{comment.likeNum}}</span>-->
              <!--                    </div>-->
            </div>
          </div>
          <div
            v-if="comment.showCommentChild && token"
            class="comment_add_box relative"
          >
            <div class="relative">
              <el-input
                v-model="comment.commentText"
                type="textarea"
                :rows="1"
                maxlength="500"
                show-word-limit
                class="font14"
                :placeholder="`回复 ${comment.userName}`"
              />
              <span class="limit_count_box">{{ comment.commentText.length }} / 500</span>
            </div>
            <div class="comment_add_btn">
              <emoji-box @select="handleSelectEmoji($event, comment)" />
              <el-button
                type="primary"
                :disabled="comment.commentText.length === 0"
                class="comment_btn"
                @click="handleSaveComment(comment.commentText, comment.id, comment)"
              >
                评论
              </el-button>
            </div>
          </div>
          <div
            v-if="comment.replyList"
            class="course_child_comment"
          >
            <div
              v-for="(child, x) in comment.replyList"
              :key="x"
              class="course_comment_item"
              :class="{ hide: !comment.showAllReply && x > 1 }"
            >
              <div class="course_comment_cover">
                <el-avatar
                  :size="48"
                  class="comment_cover_img"
                  :src="child.headPortrait"
                />
              </div>
              <div class="course_comment_content">
                <div class="course_comment_user">
                  {{ child.userName }}
                </div>
                <div
                  class="course_comment_int"
                  :class="{ 'tx-ov-2': !child.showContent }"
                >
                  回复 <span class="both">{{ child.replyUserName }}</span> :
                  {{ child.commentContent }}
                </div>
                <el-button
                  v-if="child.commentContent.length > 137"
                  type="text"
                  @click="child.showContent = !child.showContent"
                >
                  {{ child.showContent ? "收起" : "展开" }}
                </el-button>
                <div class="course_comment_btn">
                  <div class="course_comment_time">
                    {{ formatDay(child.gmtCreate) }}
                  </div>
                  <div class="comment_btn_list">
                    <!--                          <div class="btn_icons" @mouseover="handleFocus(child,'report')" @mouseleave="handleBlur(child,'report')" :class="{hover:child.report}">-->
                    <!--                            <span class="iconfont icon-report"></span>-->
                    <!--                            <span class="btn_text">举报</span>-->
                    <!--                          </div>-->
                    <div
                      v-if="userInfo && userInfo.id !== child.userId"
                      class="btn_icons"
                      :class="{ hover: child.add }"
                      @click="handleShowComment(child)"
                      @mouseover="handleFocus(child, 'add')"
                      @mouseleave="handleBlur(child, 'add')"
                    >
                      <span class="iconfont icon-comment" />
                      <span class="btn_text">回复</span>
                    </div>
                    <!--                          <div class="btn_icons" @mouseover="handleFocus(child,'love')" @mouseleave="handleBlur(child,'love')" :class="{hover:child.love,active:child.like}">-->
                    <!--                            <span class="iconfont" :class="{'icon-like':(!child.love&&!child.like),'icon-like1':child.love||child.like}"></span>-->
                    <!--                            <span class="btn_text">{{ child.likeNum }}</span>-->
                    <!--                          </div>-->
                  </div>
                </div>
                <div
                  v-if="child.showCommentChild"
                  class="comment_add_box relative"
                >
                  <div class="relative">
                    <el-input
                      v-model="child.commentText"
                      type="textarea"
                      :rows="1"
                      maxlength="500"
                      show-word-limit
                      class="font14"
                      :placeholder="`回复 ${child.userName}`"
                    />
                    <span class="limit_count_box">{{ child.commentText.length }} / 500</span>
                  </div>
                  <div class="comment_add_btn">
                    <emoji-box
                      @select="handleSelectEmoji($event, child)"
                    />
                    <el-button
                      type="primary"
                      :disabled="child.commentText.length === 0"
                      class="comment_btn"
                      @click="handleSaveComment(child.commentText, child.id, child)"
                    >
                      评论
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <el-button
              v-if="comment.replyList.length > 2"
              class="mgt20"
              type="text"
              @click="comment.showAllReply = !comment.showAllReply"
            >
              {{ comment.showAllReply ? "收起" : `查看全部${comment.replyList.length}条评论 >` }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="loading_btn">
        <el-button
          v-if="commentPage.totalPage > commentPage.pageCurrent && !map.isComment"
          type="text"
          class="warning_color"
          @click="handleScroll"
        >
          查看更多
        </el-button>
        <span
          v-if="map.isComment"
          class="loading_text"
        >加载中...</span>
        <span
          v-if="commentPage.totalPage <= commentPage.pageCurrent && !map.isComment"
          class="loading_text"
        >已经到底部，没有更多内容了</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDay } from '@/utils'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import EmojiBox from '@/components/comment/emojiBox.vue'
import { courseCommentPage, courseCommentReplySave, courseCommentSave } from '@/api/course'

export default {
  name: 'CourseComment',
  components: { EmojiBox },
  props: {
    // 课程详情数据
    courseInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const userStore = useUserStore()
    const { getToken } = userStore
    const token = computed(() => {
      return getToken()
    })
    const { courseInfo } = toRefs(props)
    const userInfo = computed(() => userStore.userView);



    const map = reactive({
      id: '',
      tabs: 'details',
      commentText: '',
      commentList: [],
      isComment: false // 是否在获取中
    })

    const commentPage = reactive({
      pageCurrent: 1,
      pageSize: 10,
      totalPage: 1,
      totalCount: 0
    })


    // 显示评论框
    const handleShowComment = (comment) => {
      comment.showCommentChild = !comment.showCommentChild
      if (comment.showCommentChild) {
        comment.commentText = ''
      }
    }

    // 选择表情
    const handleSelectEmoji = (emoji, obj) => {
      if (!obj.commentText) {
        obj.commentText = emoji + ''
      } else {
        if (obj.commentText.length + 2 <= 500) {
          obj.commentText += emoji
        }
      }
    }

    // 保存评论 有id 和 row 就是回复评论
    const handleSaveComment = (content, id, row) => {
      if (content.length > 500) {
        ElMessage.error('字数已超出限制！')
        return
      }

      // 回复评论
      if (row) {
        courseCommentReplySave({
          commentContent: content,
          goodsType: 1,
          parentId: id
        }).then((res) => {
          row.commentText = ''
          ElMessage.success(res)
          getComment()
        })
      } else {
        // 新增评论
        courseCommentSave({
          commentContent: content,
          courseId: courseInfo.value.id,
          goodsType: 1
        }).then((res) => {
          map.commentText = ''
          ElMessage.success(res)
          getComment()
        })
      }
    }

    // 获取评论列表
    const getComment = () => {
      map.isComment = true
      courseCommentPage({ courseId: courseInfo.value.id, goodsType: 1 }, commentPage.pageCurrent, commentPage.pageSize).then((res) => {
        map.isComment = false
        if (res.list) {
          res.list.forEach((el) => {
            el.commentShow = false
            el.showChild = false
            if (el.replyList) {
              el.replyList.forEach((e) => {
                e.commentShow = false
              })
            }
          })
        }
        if (commentPage.pageCurrent === 1) {
          map.commentList = res.list || []
        } else {
          res.list = res.list || []
          res.list.forEach((el) => {
            map.commentList.push(el)
          })
        }
        commentPage.pageCurrent = res.pageCurrent
        commentPage.totalPage = res.totalPage
        commentPage.totalCount = res.totalCount
      })
    }
    // 滚动到底翻页
    const handleScroll = () => {
      if (commentPage.totalPage > commentPage.pageCurrent) {
        commentPage.pageCurrent++
        getComment()
      }
    }

    // 悬浮
    const handleFocus = (row, key) => {
      row[key] = !row[key]
    }

    // 离开悬浮
    const handleBlur = (row, key) => {
      row[key] = false
    }

    onMounted(() => {
      getComment()
    })

    return {
      map,
      token,
      userInfo,
      courseInfo,
      commentPage,

      formatDay,
      handleBlur,
      handleFocus,
      handleScroll,
      handleShowComment,
      handleSaveComment,
      handleSelectEmoji
    }
  }
}
</script>

<style scoped lang="scss">
.all_txt {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  margin-bottom: 20px;
}
.comment_add_box {
  margin-bottom: 30px;
  :deep(.el-textarea__inner) {
    padding: 10px 11px;
  }
}
.comment_add_btn {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .iconfont {
    font-size: 24px;
    color: #becadb;
  }
  .comment_btn {
    width: 100px;
    height: 40px;
    font-size: 14px;
  }
}

.limit_count_box {
  background: var(--el-fill-color-blank);
  bottom: 5px;
  color: var(--el-color-info);
  font-size: 12px;
  line-height: 14px;
  position: absolute;
  right: 10px;
}
.loading_btn {
  text-align: center;
  padding-top: 11px;
  padding-bottom: 11px;
  margin-top: 20px;
  .loading_text {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #999999;
  }
}

.course_comment_item {
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  &.hide {
    display: none;
  }
  & + .course_comment_item {
    padding-top: 20px;
  }
  .course_comment_cover {
    margin-right: 20px;
  }
  .course_comment_content {
    width: calc(100% - 68px);
  }
  .course_comment_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .course_comment_btn.has {
    padding-bottom: 20px;
  }
  .course_child_comment .course_comment_btn {
    padding-bottom: 0;
  }
  .course_comment_time {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #999999;
  }
  .comment_btn_list {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .btn_icons {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #999999;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .btn_icons.active,
  .btn_icons.hover {
    color: #ff9d00;
  }
  .btn_icons:hover {
    color: #ff9d00;
  }
  .btn_icons + .btn_icons {
    margin-left: 15px;
  }
  .btn_icons .iconfont {
    font-size: 16px;
    margin-right: 3px;
  }
  .course_comment_user {
    font-style: normal;
    font-weight: 550;
    font-size: 16px;
  }
  .course_comment_int {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #999999;
  }
}
.warning_color {
  color: #ff9d00;
}
.course_child_comment {
  padding: 20px;
  background: #f6f8fb;
  border-radius: 5px;
  position: relative;
  &:before {
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    top: -7.5px;
    transform: rotate(45deg);
    background: #f6f8fb;
  }
}
</style>
